import { render } from "./PostProofreadingInstructions.vue?vue&type=template&id=7a837772&scoped=true&ts=true"
import script from "./PostProofreadingInstructions.vue?vue&type=script&lang=ts"
export * from "./PostProofreadingInstructions.vue?vue&type=script&lang=ts"

import "./PostProofreadingInstructions.vue?vue&type=style&index=0&id=7a837772&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a837772"]])

export default __exports__